export default __webpack_public_path__ + "static/media/Bodacious.73c2ab8d.jpg";